module.exports = __webpack_public_path__ + "img/menu-side-bar-2.9544fbff.svg";